var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ width: '520px', height: '270px' }),attrs:{"id":"myChart"}})}
var staticRenderFns = []

export { render, staticRenderFns }